// extracted by mini-css-extract-plugin
export default {"TeamContainer":"TeamsContainer_TeamContainer__6ujDi","HomeTeam":"TeamsContainer_HomeTeam__ICWNh"};